import React from 'react'
import '../styles/Housing.css'

function Housing() {
  return (
    <div className='housing gallery'>
        Uskoro u ponudi...
    </div>
  )
}

export default Housing